/* src/services/pushService.js */
const VAPID_PUBLIC_KEY = process.env.VUE_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {

  if (!base64String) {

    return null
  }

  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)))
}

export const pushService = {

  async subscribeUser(api) {
  
    console.log("DEBUG: Esecuzione di subscribeUser in corso...")

    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      
      console.warn('Push non supportate.')
      return
    }

    if (!VAPID_PUBLIC_KEY) {
      
      console.error("ERRORE: VAPID_PUBLIC_KEY non configurata.")
      return
    }

    try {

      const registration = await navigator.serviceWorker.ready
      let subscription = await registration.pushManager.getSubscription()

      if (!subscription) {

        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
        })
      }

      const subJSON = subscription.toJSON()

      await api.post('/push/subscribe/', {
        subscription_info: {
          endpoint: subJSON.endpoint,
          keys: {
              p256dh: subJSON.keys.p256dh,
              auth: subJSON.keys.auth
          }
        },
        browser: navigator.userAgent
      })

      console.log('Utente iscritto correttamente!')
    } 
    catch (error) {

      console.error('Errore durante la sottoscrizione push:', error)
    }
  }
}